﻿'use strict';

let angular = require('angular');

angular.module('app').controller('LoginController', require('./login.controller'));
angular.module('app').controller('PartialLoginController', require('./partial-login.controller'));